export interface CompletedItem {
  text: string;
  date: string; // YYYY-MM-DD format
}

export interface WhatsNewData {
  currentlyWorking: string[];  // From ## 🚧 DOING section
  comingNext: string[];        // From ## 📝 TODO section (first 5-8 items)
  recentlyCompleted: CompletedItem[]; // From ## ✅ DONE section (recent items with dates)
}

export const whatsNewData: WhatsNewData = {
  currentlyWorking: [
    "Public api",
    "Notebooks and workflows",
    "Adding more chart types and testing existing chart functionality",
    "Allowing you to invite/add people to your workspace"
  ],
  comingNext: [
    "Sometimes I cannot open perviously opened files from computer. Possibly because file was deleted?",
    "chart viewer -> make faster when changing between charts.",
    "in datasets automatically create tables based on some interesting queries from ai agent. Maybe have a source:generated to track these",
    "Building native desktop app to replace the PWA. This will be faster and feel more like a desktop app.",
    "In what's new modal support adding embedded tweets. They might have video, which would be nice for feature demo",
    "Add crossfilterable dashboards (novaboards?) and pivot tables. Scope to dataset initially",
    "Add chat (Novachat). Scope to dataset but maybe later have more global scope options",
    "Tracking on dataset views so we can show users how many views their datasets have"
  ],
  recentlyCompleted: [
    // June 1, 2025 items from todo.md DONE section
    {
      text: "Added charts. Currently you can only save tables with filters. But more chart types coming soon!",
      date: "2025-06-01"
    },
    {
      text: "Added workspaces so you can work with your team",
      date: "2025-06-01"
    },
    {
      text: "Internal alpha of public api. Starting with file conversion but more coming soon!",
      date: "2025-06-01"
    },
    {
      text: "Internal alpha of AI notebooks and workflows",
      date: "2025-06-01"
    },
    {
      text: "Make nav rail clearer and more consistent",
      date: "2025-06-01"
    },
    {
      text: "Modified save button on /app page to create chart and redirect to chart view instead of just creating dataset",
      date: "2025-06-01"
    },
    {
      text: "Fixed save button in dataset viewer to pass current chart configuration instead of creating empty charts",
      date: "2025-06-01"
    },
    // May 31, 2025 items from todo.md DONE section
    {
      text: "Replace the table viewer with an infinite scrolling version. Makes it faster, easier and more intuitive to view large tables now.",
      date: "2025-05-31"
    },
    // May 30, 2025 items from todo.md DONE section
    {
      text: "Let user create dataset from the /app viewer",
      date: "2025-05-30"
    },
    {
      text: "Automatically create names for new datasets",
      date: "2025-05-30"
    },
    {
      text: "order datasets in sidebar based on most recently viewed",
      date: "2025-05-30"
    },
    {
      text: "Fix bug in dataset sidebar where no datasets shown",
      date: "2025-05-30"
    },
    {
      text: "In datasets sidebar list recenly opened github datasets",
      date: "2025-05-30"
    },
    {
      text: "Improve some background jobs to make them faster and decrease chance of hitting rate limits for file converters",
      date: "2025-05-30"
    },
    {
      text: "Fix bug where datasets don't progressively load when importing in background for datasets with many files",
      date: "2025-05-30"
    },
    {
      text: "fix bug where some images in the dataset about were flickering",
      date: "2025-05-30"
    },
    {
      text: "fix issue where dataset sidebar scrolled when having multiple types of dataset listed",
      date: "2025-05-30"
    },
    {
      text: "fix janky page scroll on datasets/id page caused by performance issue",
      date: "2025-05-30"
    },
    // May 29, 2025 items from todo.md DONE section
    {
      text: "Improve performance when loading tables for the second time. Instead of downloading again we just keep them in the browser.",
      date: "2025-05-29"
    },
    {
      text: "Internal engineering to make it easier to add features and reduce bugs",
      date: "2025-05-29"
    },
    // May 28, 2025 items from todo.md DONE section
    {
      text: "Remote data tables load and query quickly when under 50MB now. Hopefully all dataset performance issues fixed. Over 50MB will still be slow. Those files would be better with desktop app.",
      date: "2025-05-28"
    },
    // May 27, 2025 items from todo.md DONE section
    {
      text: "Fixed performance issue with loading tables in datasets with many tables.",
      date: "2025-05-27"
    },
    {
      text: "Fixed issue for pro users where nova chat was re-prompted every time new datatable loaded",
      date: "2025-05-27"
    },
    {
      text: "Fixed issue where loading indicator not showing while queries running",
      date: "2025-05-27"
    },
    // May 26, 2025 items from todo.md DONE section
    {
      text: "Significantly improved first github dataset page load speed.",
      date: "2025-05-26"
    },
    // May 25, 2025 items from todo.md DONE section
    {
      text: "Significantly improved dataset page load speed - reduced load time from 10-30 seconds to 1-2 seconds for datasets with many tables",
      date: "2025-05-25"
    },
    {
      text: "Add Home to header to fix navigation issue when someone accidentally leaves the main app area",
      date: "2025-05-25"
    },
    {
      text: "Datasets are now imported more reliably. Especially for those with a lot of files.",
      date: "2025-05-25"
    },
    {
      text: "Update What's New modal to include recently items being worked on and upcoming items",
      date: "2025-05-25"
    },
    // May 24, 2025 items from todo.md DONE section
    {
      text: "Significantly improved loading speed when opening files from desktop applications",
      date: "2025-05-24"
    },
    {
      text: "Enhanced user dropdown menu with better organized options for logged in users",
      date: "2025-05-24"
    },
    {
      text: "Added changelog to show recent updates and improvements",
      date: "2025-05-24"
    },
    {
      text: "Optimized file handling performance for faster app responsiveness",
      date: "2025-05-24"
    }
  ]
};

// Legacy exports for backwards compatibility (remove when all imports are updated)
export const changelog = [];
export interface ChangelogEntry {
  date: string;
  features: string[];
  fixes: string[];
  improvements: string[];
  breakingChanges?: string[];
} 